import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import TransferMajorLactsCategoryDataTable from '../../../../components/datatables/postSecondary/TransferMajorLactsCategoryDataTable';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import HeaderPortal from '../../../../portals/HeaderPortal';
import HistoryUtil from '../../../../utils/HistoryUtil';

interface TransferMajorLactsCategoryListProps {
}

interface TransferMajorLactsCategoryListState {
}

class TransferMajorLactsCategoryListPage extends React.Component<TransferMajorLactsCategoryListProps & RouteComponentProps<RouteObject>, TransferMajorLactsCategoryListState> {
  constructor(props: TransferMajorLactsCategoryListProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  private goToConfig = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content>
        <HeaderPortal title="Transfer Major Lacts Categories" onBack={this.goToConfig} breadcrumbs={Breadcrumbs.transferMajorLactsCategoryList()} />

        <Card >
          <TransferMajorLactsCategoryDataTable />
        </Card>
      </Content>
    );
  }
}

export default withRouter(TransferMajorLactsCategoryListPage);
